const reducerInitialState = {
  initialMakeModelSearch: undefined,
  make: undefined,
  model: undefined,
  hasMakeFormErrors: false,
  hasModelFormErrors: false
}

const actions = {
  SET_MAKE: 'SET_MAKE',
  SET_MODEL: 'SET_MODEL',
  SET_MAKE_FORM_ERRORS: 'SET_MAKE_FORM_ERRORS',
  SET_MODEL_FORM_ERRORS: 'SET_MODEL_FORM_ERRORS'
}

const reducer = (state, action) => {
  switch (action.type) {
    case actions.SET_MAKE:
      return {
        ...state,
        make: action.payload,
        initialMakeModelSearch: {makeId: action.payload?.id},
        hasMakeFormErrors: false
      }
    case actions.SET_MODEL:
      return {
        ...state,
        model: action.payload,
        initialMakeModelSearch: {
          ...state.initialMakeModelSearch,
          modelId: action.payload?.id
        },
        hasModelFormErrors: false
      }
    case actions.SET_MAKE_FORM_ERRORS:
      return {
        ...state,
        hasMakeFormErrors: action.payload
      }
    case actions.SET_MODEL_FORM_ERRORS:
      return {
        ...state,
        hasModelFormErrors: action.payload
      }
    default:
      return state
  }
}

export {actions, reducerInitialState, reducer}
